export const createDraggablePortalElement = (id: string): HTMLDivElement => {
  const div = document.createElement('div');
  div.setAttribute('draggable-portal-container', id);
  document.body.appendChild(div);

  return div;
};
